<template>
	<div class="levelindicators">
		<div class="title">
			3 二级指标 部门不合格分布
		</div>
		<div class="levelbox">
			<div id="level_echarts">
				
			</div>
			<div class="biaoge">
				<table cellpadding="0" cellspacing="0">
					<tr>
						<th v-for="item,index in x" :key="index">{{item}}</th>
					</tr>
					<tr>
						<td v-for="item,index in finish" :key="index">{{item}}</td>
					</tr>
					<tr>
						<td v-for="item,index in  handle" :key="index">{{item}}</td>
					</tr>
				</table>
				<table class="biaogetitle" cellpadding="0" cellspacing="0">
					<tr>
						<td>已完成</td>
					</tr>
					<tr>
						<td>处理中</td>
					</tr>
				</table>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
	  name: "",
	  data() {
	  	return{
			finish:[5,10,2,4,6,5],
			handle:[5,3,7,1,7,10],
			x:['x站位','x站位','x站位','x站位','x站位','x站位'],
			all:[10,13,9,5,13,15],
			handleflag:true,
			finishflag:true,
		}
	  },
	  methods: {
	  fontSize(res,initWidth=1920){
					var nowClientWidth = document.documentElement.clientWidth;
					return res*(nowClientWidth/initWidth);
				},
	   echartsLine(){
		   var echarts = require('echarts');
		   let energyConsumption = echarts.init(document.getElementById('level_echarts'));
		   energyConsumption.setOption({
			   tooltip: {},
			     legend: {
					 show:true,
					 bottom: "0%",
				 },
				 grid: {
				     left: "15%",
				     top: "5%",
				     right: "15%",
				     bottom: "30%"
				   },
			     xAxis: {
			       data:this.x,
				    show: false
			     },
			     yAxis: {
					 boundaryGap: true
				 },
			     series: [{
			       name: "处理中",
			       type: "bar",
				   stack :'zhanwei',
				   barWidth: "40%",
				   itemStyle: {
				         color: "rgba(85, 255, 127, 1.0)"
				       },
				   label: {
				         show: true
				       },
					data:this.handle 
			       
			     },
				 {
					name: "已完成",
					type: "bar",
					stack :'zhanwei',
					barWidth: "40%",
					itemStyle: {
					      color: "rgba(255, 255, 0, 1.0)"
					    },
					label: {
					      show: true,
					    },
					data:this.finish
				 },
				 {                               //新的一个柱子 注意不设stack
					       
					 type: 'bar',  
					 barGap: '-100%',         // 左移100%，stack不再与上面两个在一列
					 label: {                 
						 normal: {
							 show: true, //显示数值
							 position: 'top',       //  位置设为top
							 formatter: '{c}',
							 textStyle: { color: '#000' } //设置数值颜色
						 }
					 },
					 itemStyle: {
						 normal: {
							 color: 'rgba(128, 128, 128, 0)' // 设置背景颜色为透明
						 }
					 },
					 data: this.update(),
				  }
				 ]
			})
			window.addEventListener("resize", () => {
			  energyConsumption.resize();
			});
			energyConsumption.on('legendselectchanged',  (obj)=> {
						this.finishflag=obj.selected.已完成
						this.handleflag=obj.selected.处理中
					    this.echartsLine()
				})
				
			},
			update(){
						var arr=[{name:'已完成',flag:this.finishflag,arr:this.finish},{name:'处理中',flag:this.handleflag,arr:this.handle}]
						var all=[];
						arr.forEach((item,index)=>{
							if(item.flag){
								if(all.length<5){
									all=all.concat(item.arr)
								}else{
									all.forEach((val,index)=>{
										all[index]+=item.arr[index]
									})
								}
								
							}
						})
						this.all=all
						return this.all
			}
	  },
	  mounted() {
	     this.echartsLine();
		 window.addEventListener("resize", () => {
		    this.echartsLine();
		 });
		 
		 
	  }
	};
</script>

<style scoped="scoped">
	.levelindicators{
		position: relative;
		width: 50%;
		height: 50%;
		background: #FFFFFF;
		position: fixed;
		top: 100px;
		margin-left: -25%;
		left:50%;
	}
	.title{
		height: 10%;
		background: #FFFFFF;
	}
	.levelbox{
		position: absolute;
		width: 100%;
		height: 90%;
	}
	#level_echarts{
		height: 100%;
		width: 100%;
	}
	.biaoge{
		position: absolute;
		width: 70%;
		height: 20%;
		left: 50%;
		margin-left: -35%;
		bottom: 10%;
	}
	.biaoge>table.biaogetitle{
		position: absolute;
		left: -10%;
		width:10%;
		border-right: none;
		height: 67%;
		bottom: 0;
		
	}
	.biaoge>table.biaogetitle td{
		height: 50%;
	}
	.biaoge>table{
		width: 100%;
		height: 100%;
		border-top: 1px solid #999;
		border-right: 1px solid #999;
	}
	.biaoge>table th{
		font-weight: normal;
		font-size: .8vw;
	}
	.biaoge>table td,th{
		border-bottom: 1px solid #999;
		border-left: 1px solid #999;
		text-align: center;
	}
	.biaoge>table td{
		font-size: .6vw;
		height: 33%;
	}
</style>